<bringoz-button type="tertiary"
                size="fit"
                id="job-action-menu-{{job?.id}}"
                (click)="$event.stopPropagation(); onOpen.emit($event)">
  <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
</bringoz-button>